import { withTranslation } from 'react-i18next';

import Button from '@components/Common/Button';

import style from './style.module.css';

const TooShortWindow = ({ handleClose, t = () => {} }) => {
  return (
    <div className={style.root}>
      <h1>{t('Oups!')}</h1>
      <p>{t('Your video doesn’t have a minimum of 20 sec. Your video is not saved. You’ll have to redo the step from the beginning.')}</p>
      <div className={style.buttonContainer}>
        <Button theme="PRIMARY" onClick={handleClose}>
          {t('Record again')}
        </Button>
      </div>
    </div>
  );
};

export default withTranslation()(TooShortWindow);
